<template>
    <div class="card card-custom card-stretch gutter-b" v-loading="loading">
        <div class="card-header">
            <div class="card-title">
                <h3 class="card-label title-header">
                    <div class="row ">
                        <i class="flaticon2-delivery-package text-primary align-self-center"></i>
                        <b class="ml-4">{{ BusinessTitle }}</b>
                    </div>
                    <div class="row mt-1">
                        <b class="ml-8 d-flex align-items-end">＜予実対比＞</b>
                        <button class="btn btn-primary align-self-end ml-4"
                                @click="toNext('actual')">予実混合
                        </button>
                    </div>
                </h3>
            </div>


        </div>
        <div class="card-body">
            <div>
                <div v-if="business_from && business_to">
                    <p class="mb-0">事業期間：</p>
                    <p>{{ `${business_from} ~ ${business_to}` }}</p>
                </div>
                <p>表示期間</p>
            </div>
            <div class="mb-4">
                <div>
                    <el-form ref="ruleForm" :model="form" class="form-base" v-on:submit.prevent="isSubmit = true">
                        <div class="row ml-0" style=" align-items: center;">
                            <div class="col- mr-2">
                                <el-form-item class="mb-0" prop="dateStart">
                                    <el-date-picker v-model="form.day_from.year" :picker-options="pickerOptions"
                                                    type="year" :clearable="false" value-format="yyyy"
                                                    prefix-icon="el-icon-arrow-down" @change="sortDate()"
                                                    :editable="false"></el-date-picker>
                                    <span> 年 </span>
                                    <el-date-picker v-model="form.day_from.month" :picker-options="pickerOptions"
                                                    type="month" :clearable="false" format="MM"
                                                    prefix-icon="el-icon-arrow-down" @change="sortDate()"
                                                    :default-value="form.day_from.year ? fromYear : new Date()"
                                                    :editable="false">
                                    </el-date-picker>
                                    <span> 月 </span>
                                </el-form-item>
                            </div>

                            <div class="center-line mr-4">
                                <p style="font-size: 20px;margin-bottom: 0;"> ～ </p>
                            </div>

                            <div class="col- mr-6">
                                <el-form-item class="mb-0" prop="dateEnd">
                                    <el-date-picker v-model="form.day_to.year" :picker-options="pickerOptions"
                                                    type="year"
                                                    :clearable="false" value-format="yyyy"
                                                    prefix-icon="el-icon-arrow-down" @change="sortDate()"
                                                    :editable="false"></el-date-picker>
                                    <span> 年 </span>
                                    <el-date-picker v-model="form.day_to.month" :picker-options="pickerOptions"
                                                    type="month"
                                                    :clearable="false" format="MM" prefix-icon="el-icon-arrow-down"
                                                    @change="sortDate()"
                                                    :default-value="form.day_to.year ? toYear : new Date()"
                                                    :editable="false">
                                    </el-date-picker>
                                    <span> 月 </span>
                                </el-form-item>
                            </div>

                            <div class="col-">
                                <el-form-item prop="tax_flag" class="mb-0">
                                    <el-select v-model="tax_flag" placeholder="">
                                        <el-option
                                            v-for="item in tax_options"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>
                        <input type="hidden" name="_csrf" v-model="form._csrf" />
                    </el-form>
                </div>
                <div class="row ml-4 mb-4 align-items-end justify-content-between">
                    <div class="row align-items-end">
                        <div class="col-auto">
                            <div class="mr-40">予算額: {{ yosan_gaku_sum ? formatter(yosan_gaku_sum) : '--' }}</div>
                        </div>
                        <div class="col-auto">
                            <div class="mr-40">実績額: {{ jisseki_gaku_sum ? formatter(jisseki_gaku_sum) : '--' }}</div>
                        </div>
                        <div class="col-auto">予算消化率: {{ budgetRate }}</div>
                    </div>
                    <div class="text-right">
                        <button class="btn btn-primary mr-2" @click="toNext('update')">更新</button>
                    </div>
                </div>
            </div>
            <div class="table-main">
                <table class="tg w-100 table table-bordered">
                    <thead>
                    <tr>
                        <th class="tg-0lax m-width th-sticky" :class="{ 'table-fix-2': months.length < 5 }" colspan="1" rowspan="2">
                            <strong>費目カテゴリ</strong>
                        </th>
                        <th class="tg-0lax m-width th-sticky1" colspan="2" rowspan="2">
                            <strong>費目</strong>
                        </th>
                        <th class="tg-0lax m-width th-sticky2" :class="{ 'table-fix-2': months.length < 5  }" colspan="3" rowspan="2">
                            <strong>再委託費目</strong>
                        </th>
                        <th v-for="month in months" :key="month" colspan="2" class="tg-0lax">
                            <strong>{{ month }}</strong>
                        </th>
                    </tr>
                    <tr>
                        <template v-for="month in months">
                            <th class="tg-0lax">
                                <strong>予算</strong>
                            </th>
                            <th class="tg-0lax">
                                <strong>実績</strong>
                            </th>
                        </template>

                    </tr>
                    </thead>
                    <template v-if="months.length">
                        <tbody v-for="dataListLv1 in dataList">
                    <template v-for="(dataListLv2,dataListLv2Key) in dataListLv1">
                        <template v-for="(dataListLv3,dataListLv3Key) in dataListLv2">
                            <template v-if="dataListLv3Key !=getLastkey(dataListLv2)"
                                      v-for="(dataListLv4,dataListLv4Key) in dataListLv3">
                                <tr :class="dataListLv4Key">
                                    <td v-if="isFirstLoop(dataListLv4Key, dataListLv3) && isFirstLoop(dataListLv3Key, dataListLv2)"
                                        class="tg-0lax menu-level-1"
                                        :rowspan="tinhTongSoPhanTuCon(dataListLv2,getLastkey(dataListLv2)) + 1">
                                        <el-tooltip :content="replaceSpecialName(dataListLv2Key)" placement="top">
                                            <span>{{ replaceSpecialName(dataListLv2Key) }}</span>
                                        </el-tooltip>
                                    </td>
                                    <td v-if="isFirstLoop(dataListLv4Key, dataListLv3)" class="tg-0lax menu-level-2"
                                        :rowspan="countDirectElements(dataListLv3)">
                                        <el-tooltip :content="replaceSpecialName(dataListLv3Key)" placement="top">
                                            <span>{{ replaceSpecialName(dataListLv3Key) }}</span>
                                        </el-tooltip>
                                    </td>
                                    <td class="tg-0lax menu-level-3" colspan="4">
                                        <el-tooltip
                                            :content="dataListLv4Key != 't_jimukanri_himoku' ? replaceSpecialName(dataListLv4Key) : ''"
                                            placement="top">
                                            <span>{{
                                                    dataListLv4Key != 't_jimukanri_himoku' ? replaceSpecialName(dataListLv4Key) : ''
                                                }}</span>
                                        </el-tooltip>
                                    </td>
                                    <template v-for="month in months">
                                        <td class="tg-0lax1 set-width">{{
                                                findValueItem(dataListLv4, month, 'form2')
                                            }}
                                        </td>
                                        <td class="tg-0lax1 set-width">{{
                                                findValueItem(dataListLv4, month, 'form3')
                                            }}
                                        </td>
                                    </template>
                                </tr>
                            </template>
                            <template v-if="dataListLv3Key == getLastkey(dataListLv2)">
                                <tr>
                                    <td class="tg-0lax menu-total-level-1 td-menu-total-level-1-sticky" colspan="5">
                                        {{ dataListLv3Key }}
                                    </td>
                                    <template v-for="month in months">
                                        <td class="tg-0lax inline-color menu-total-level-1-1">
                                            {{ findValueItem(dataListLv3, month, 'form2') }}
                                        </td>
                                        <td class="tg-0lax inline-color menu-total-level-1-1">
                                            {{ findValueItem(dataListLv3, month, 'form3') }}
                                        </td>
                                    </template>
                                </tr>
                            </template>
                        </template>
                    </template>
                    </tbody>
                        <tbody class="end-line">
                    <tr>
                        <td class="tg-0pky text-center m-width menu-total-level-2 td-menu-total-level-2-sticky"
                            colspan="6">合計
                        </td>
                        <template v-for="month in months">
                            <td class="tg-0pky text-center menu-total-level-2-2">
                                {{ findValueItem(totalInMonth, month, 'form2', true) }}
                            </td>
                            <td class="tg-0pky text-center menu-total-level-2-2">
                                {{ findValueItem(totalInMonth, month, 'form3', true) }}
                            </td>
                        </template>
                    </tr>
                    </tbody>
                    </template>
                    <template v-else>
                        <tbody>
                            <td colspan="10">検索結果がありません。条件を変更して再度検索してください。</td>
                        </tbody>
                    </template>
                </table>
            </div>

        </div>
    </div>
</template>

<script>
import moment from 'moment'
import {mapActions, mapGetters} from 'vuex';
import {SET_TITLE_BUSINESS} from "@/core/services/store/business.module";
import { getCsrfRandom } from "@/core/services/store/auth.module";

export default {
    data() {
        return {
            isFirstInter3Loop: true,
            header: [],
            total: 42,
            dataList: [],
            secondLoopReached: false,
            loading: false,
            listHeaders: [],
            totalInMonth: {},
            yosan_gaku_sum: 0,
            yosan_gaku_sum_flag: 0,
            jisseki_gaku_sum: 0,
            jisseki_gaku_sum_flag: 0,
            total_tax_sum: 0,
            hasActual: [],
            pickerOptions: {
                disabledDate: this.disabledDate
            },
            tax_flag: 0,
            tax_rate: 0,
            form: {
                day_from: {
                    year: null,
                    month: null
                },
                day_to: {
                    year: null,
                    month: null
                },
                 _csrf:''
            },
            business_from: '',
            business_to: '',
            budgetData: {},
            tax_options: [
                {
                    value: 1,
                    label: '税込み表示'
                },
                {
                    value: 0,
                    label: '税抜き表示'
                }
            ],
            months: []
        };
    },
    watch: {
        'form.day_from.year': {
            handler: function () {
                if (!this.isSubmit && this.form.day_from.year && this.form.day_from.month) {
                    this.form.day_from.month = new Date(
                        this.form.day_from.year ? moment(this.form.day_from.year).format('yyyy') : new Date().getFullYear(),
                        this.form.day_from.month ? moment(this.form.day_from.month).format('MM') - 1 : new Date().getMonth()
                    )
                }
            },
            deep: true
        },
        'form.day_from.month': {
            handler: function () {
                if (!this.isSubmit) {
                    this.form.day_from.year = this.form.day_from.month ? moment(this.form.day_from.month).format('yyyy') : this.form.day_from.year
                }
            },
            deep: true
        },
        'form.day_to.year': {
            handler: function () {
                if (!this.isSubmit && this.form.day_to.year && this.form.day_to.month) {
                    this.form.day_to.month = new Date(
                        this.form.day_to.year ? moment(this.form.day_to.year).format('yyyy') : new Date().getFullYear(),
                        this.form.day_to.month ? moment(this.form.day_to.month).format('MM') - 1 : new Date().getMonth()
                    )
                }
            },
            deep: true
        },
        'form.day_to.month': {
            handler: function () {
                if (!this.isSubmit) {
                    this.form.day_to.year = this.form.day_to.month ? moment(this.form.day_to.month).format('yyyy') : this.form.day_to.year
                }
            },
            deep: true
        },
        form: {
            handler: async function () {
                if (this.form.day_from.year && this.form.day_from.month && this.form.day_to.year && this.form.day_to.month) {
                    this.$refs["ruleForm"].clearValidate()
                    const time = {
                        dateStart: `${this.form.day_from.year}-${moment(this.form.day_from.month).format('MM')}`,
                        dateEnd: `${this.form.day_to.year}-${moment(this.form.day_to.month).format('MM')}`,
                        isUpdate: 0,
                        tax_flag: 0
                    }
                    this.betweenTime(time)
                    this.getListDataV2(time)
                }
            },
            deep: true
        },
        tax_flag: {
            handler: function () {
                this.yosan_gaku_sum = this.calcuMony(this.yosan_gaku_sum_flag)
                this.jisseki_gaku_sum = this.calcuMony(this.jisseki_gaku_sum_flag)
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters(['BusinessTitle', 'getBusiness', 'getListTransaction', 'ForecastErrors', 'ForecastStatus', 'getListTitle']),
        fromYear() {
            return this.form.day_from.year ? moment(this.form.day_from.year).format('yyyy') : new Date().getFullYear()
        },
        fromMonth() {
            return this.form.day_from.month ? moment(this.form.day_from.month).format('MM') - 1 : new Date().getMonth()
        },
        toYear() {
            return this.form.day_to.year ? moment(this.form.day_to.year).format('yyyy') : new Date().getFullYear()
        },
        toMonth() {
            return this.form.day_to.month ? moment(this.form.day_to.month).format('MM') - 1 : new Date().getMonth()
        },
        budgetRate() {
            return ((this.jisseki_gaku_sum && this.jisseki_gaku_sum != '--')
                && (this.yosan_gaku_sum && this.yosan_gaku_sum != '--')) ?
                Number((this.jisseki_gaku_sum / this.yosan_gaku_sum) * 100).toFixed(2) + '%' : '--'
        }
    },
    async created() {
        this.loading = true;
        if (this.BusinessTitle == null) {
            await this.setTitleBusiness()
        }

        if (this.getBusiness) {
            this.form.day_from.month = new Date(this.getBusiness.jigyo_kikan_from)
            this.form.day_to.month = new Date(this.getBusiness.jigyo_kikan_to)

            this.business_from = moment(this.getBusiness.jigyo_kikan_from).format('YYYY/MM/DD')
            this.business_to = moment(this.getBusiness.jigyo_kikan_to).format('YYYY/MM/DD')
        }

        let query = {};
        if (this.$route.query.dateStart) {
            query.dateStart = this.$route.query.dateStart
            const get_year = query.dateStart.indexOf('-');
            this.form.day_from.year = query.dateStart.slice(0, get_year)
            this.form.day_from.month = new Date(query.dateStart)
        }
        if (this.$route.query.dateEnd) {
            query.dateEnd = this.$route.query.dateEnd
            const get_year = query.dateEnd.indexOf('-');
            this.form.day_to.year = query.dateEnd.slice(0, get_year)
            this.form.day_to.month = new Date(query.dateEnd)
        }
        this.form._csrf = getCsrfRandom()
        this.loading = false;
    },
    methods: {
        ...mapActions(['listTransaction', 'listTransactionV2', 'listTransactionV3', 'listBudgetPreComparision', SET_TITLE_BUSINESS]),
        formatCost(row, col, value, index) {
            if (value == undefined || value == "--") {
                return "--"
            }

            const arr = value.split('.')
            const beforeDot = arr[0]
            const afterDot = arr[1] ? arr[1] : null


            const cost = value ? BigInt(beforeDot) : undefined
            const formatter = new Intl.NumberFormat('ja-JP', {currency: "JPY"}).format(cost)

            if (afterDot) {
                return (cost || cost == 0n) ? `${formatter}.${afterDot}` : `${cost}.${afterDot}`
            } else {
                return (cost || cost == 0n) ? formatter : cost
            }
        },
        formatter(unformated_cost) {
            if (unformated_cost == '--') {
                return unformated_cost
            }
            const arr = unformated_cost.toString().split('.')
            const beforeDot = arr[0]
            const afterDot = arr[1] ? arr[1] : null

            const cost = BigInt(beforeDot)
            const formatter = new Intl.NumberFormat('ja-JP', {currency: "JPY"}).format(cost)

            return afterDot ? `${formatter}.${afterDot}` : formatter
        },
        sortDate() {
            //not yet implement
        },
        disabledDate(date) {
            return moment(date).isBefore(this.getBusiness.jigyo_kikan_from) || moment(date).isAfter(this.getBusiness.jigyo_kikan_to)
        },
        toNext(next) {
            let dateStart = null
            let dateEnd = null

            if (this.form.day_from.year && this.form.day_from.month) {
                dateStart = `${this.form.day_from.year}-${moment(this.form.day_from.month).format('MM')}`
            }
            if (this.form.day_to.year && this.form.day_to.month) {
                dateEnd = `${this.form.day_to.year}-${moment(this.form.day_to.month).format('MM')}`
            }

            this.$router.push({
                name: next == 'update' ? 'confirm-submit' : 'budget-pre-actual-report', query: {
                    dateStart,
                    dateEnd
                }
            })
        },
        isFirstLoop(key4, inter3) {
            return Object.keys(inter3)[0] === key4;
        },
        isSecondLoop(key4, inter3) {
            return Object.keys(inter3)[0] === key4 || Object.keys(inter3)[1] === key4;
        },
        arraySpanMethod({row, column, rowIndex, columnIndex}) {
            if (rowIndex % 2 === 0) {
                if (columnIndex === 0) {
                    return [1, 2];
                } else if (columnIndex === 1) {
                    return [0, 0];
                }
            }
        },

        objectSpanMethod({row, column, rowIndex, columnIndex}) {
            if (columnIndex === 0) {
                if (rowIndex % 2 === 0) {
                    return {
                        rowspan: 2,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
        },
        tinhTongSoPhanTuCon(obj, lastkey) {
            var tong = 0;
            for (var key in obj) {
                if (obj.hasOwnProperty(key)) {
                    if (typeof obj[key] === 'object') {
                        if (key != lastkey) tong += Object.keys(obj[key]).length;
                    }
                }
            }
            return tong;
        },
        countDirectElements(obj) {
            return Object.keys(obj).length;
        },
        getLastkey(obj) {
            return Object.keys(obj).pop();
        },
        async getListDataV2(time) {
            this.loading = true
            const response = await this.listBudgetPreComparision(time)
            if (response.code == 200) {
                this.dataList = [response.data.data]
                this.header = response.data.byTime
                this.totalInMonth = response.data.totalInMonth
                this.yosan_gaku_sum_flag = response.data.totalForm2
                this.yosan_gaku_sum = response.data.totalForm2
                this.jisseki_gaku_sum_flag = response.data.totalForm3
                this.jisseki_gaku_sum = response.data.totalForm3
                this.tax_rate = response.data.tax
            }
            if (response.code == 422) {
                this.yosan_gaku_sum = '--'
                this.yosan_gaku_sum_flag = '--'
                this.jisseki_gaku_sum = '--'
                this.jisseki_gaku_sum_flag = '--'
                this.showErrorMessage(response.data, "ruleForm")
            }
            this.loading = false

        },
        calcuMony(int) {
            if (int != undefined && int != "--" && int != 0) {
                if (this.tax_rate != 0 && this.tax_flag == 1) {
                    let result = int * (1 + this.tax_rate / 100)
                    return this.formatNumber(result)
                }
                return this.formatNumber(int)

            }
            return "--"
        },
        formatDateHeader(date) {
            return moment(date).format('YYYY/MM')
        },
        convertWhoForm(date) {
            const convertedDate = date.replace(/\//g, "-");
            if (convertedDate) {
                if (this.header[convertedDate] && this.header[convertedDate] == 'form3') {
                    return '実績'
                }
                return '予算'
            }
            return '予算'
        },
        findValueItem(list, key, formName, flag = false) {

            key = key.replace(/\//g, "-");
            if (list[key] && list[key][formName]) {
                return this.calcuMony(list[key][formName]);
            } else {
                return '--'

            }
        },
        betweenTime(timeSearch) {
            const startDate = moment(`${timeSearch.dateStart}-01`);
            const endDate = moment(`${timeSearch.dateEnd}-01`);
            const months = [];
            while (startDate.isSameOrBefore(endDate, 'month')) {
                // Định dạng ngày tháng thành "YYYY/MM"
                const monthYear = startDate.format('YYYY/MM');
                months.push(monthYear);
                // Tăng tháng
                startDate.add(1, 'month');
            }
            this.months = months
        }
    }
}
</script>

<style scoped>

.th-sticky, th {
    background-color: rgb(24, 28, 50);
    color: white !important;
}

.th-sticky1 {
    /*background-color: rgb(24, 28, 50);*/
}

.th-sticky2 {
    /*background-color: rgb(24, 28, 50);*/
}

.menu-level-1 {
    background-color: white !important;
}

.menu-level-2 {
    background-color: white !important;
}

.menu-level-3 {
    background-color: white !important;
}

.menu-total-level-1 {
    position: sticky !important;
    left: 100px;
    background-color: white !important;
    color: red !important;
}

.menu-total-level-1-1, .menu-total-level-2-2 {
    color: red !important;
    background-color: white;
}

.menu-total-level-2 {
    position: sticky !important;
    left: 0px;
    background-color: white !important;
    color: red !important;
}

.th-sticky2, .menu-level-3 {
    position: sticky !important;
    left: 230px;
    width: 200px !important;
    min-width: 200px !important;
    max-width: 200px !important;
    border:none;
}

.th-sticky1, .menu-level-2 {
    position: sticky !important;
    left: 100px;
    width: 130px !important;
    min-width: 130px !important;
    max-width: 130px !important;
    border:none;
    box-shadow: inset -1px -1px #EBEEF5, inset 1px 1px #EBEEF5, inset -1px 1px #EBEEF5, inset 1px -1px #EBEEF5;
}

.th-sticky, .menu-level-1 {
    position: sticky;
    left: 0px;
    width: 100px !important;
    min-width: 100px !important;
    max-width: 100px !important;
    /*border: 4px solid black;*/
    border:none;
    box-shadow: inset -1px -1px #EBEEF5, inset 1px 1px #EBEEF5, inset -1px 1px #EBEEF5, inset 1px -1px #EBEEF5;
}

.tg td, th {
    /*border: 4px solid black;*/
    border:none;
    box-shadow: inset -1px -1px #EBEEF5, inset 1px 1px #EBEEF5, inset -1px 1px #EBEEF5, inset 1px -1px #EBEEF5;
    font-size: 14px;
    overflow: hidden;
    font-family: Poppins, Helvetica, "sans-serif";
    padding: 9px;
    word-break: normal;
    color: #606266;
    font-weight: 500;
    text-overflow: unset;
    text-overflow: ellipsis;
    text-align: center;
    white-space: nowrap;
}

.table thead th , td {
    vertical-align: middle;
     border-bottom: none;
}

.table-main {
    overflow: auto;
}

table {
    overflow: auto;
    empty-cells: hide;
    border-collapse:  collapse;
    background-color: #EBEEF5;
    empty-cells: hide;
    background-color: gray;
}

.set-width {
    min-width: 100px;
    max-width: 100px;
    background-color: white;
}
.table tbody + tbody {
    border-top: none;
}
.end-line {
    border-bottom: 1px solid #EBEEF5;
}
.table-fix-2 {
    width: 12% !important;
}
</style>
